import { Divider } from "antd";
import React from "react";
import { useState,useEffect } from "react";
import Navbar from "../global-components/navbar";
import Footer_v1 from "../global-components/footer";
import BlogContact from "../../utils/blogContact";
import PageHeaderDeveloper from "./developerHeader";
import DeveloperList from "./developerlist"
import { Helmet } from "react-helmet";

const Developer = () =>{
    return(
        <div>
            <Helmet>
            <title>Top Real Estate Developers in Dubai – Trinest Sky </title>
            <meta name="description" content="Discover top property developers in Dubai. Learn about their latest projects, upcoming launches, and investment opportunities in Dubai’s real estate market." />
        </Helmet>
            <Navbar />
            <PageHeaderDeveloper headertitle="Developers"/>
           <DeveloperList />
            <BlogContact />
            <Footer_v1 />
        </div>
    );
};
 export default Developer